






import { Component, Inject, InjectReactive, Vue } from 'vue-property-decorator';

import { User } from '@/api';
import { FeedProduct } from '../../models';

import UsersTable from '@/components/tables/users-table.vue';
import AddUser from '@/components/add business objects/addUser.vue';
import { canAddUsers } from '@/services/user-service';
import RepairJobTexts from '@/components/tables/repair-job-texts.vue';

@Component({
	components: {
		UsersTable,
		AddUser,
		RepairJobTexts,
	},
})
export default class FeedProductRepairJobTextsTab extends Vue {
	@InjectReactive('feedProduct')
	private feedProduct!: FeedProduct;
}
